import React from 'react'

export const InfoButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="#8B8B8B"
      d="M21.6 12a9.6 9.6 0 10-19.2 0 9.6 9.6 0 0019.2 0zm-10.19-1.308a.6.6 0 011.18 0l.01.108v5.403l-.01.108a.6.6 0 01-1.18 0l-.01-.108V10.8l.01-.108zM11.1 8.1a.9.9 0 111.8 0 .9.9 0 01-1.8 0z"
    />
  </svg>
)
